import { render, staticRenderFns } from "./noise.vue?vue&type=template&id=34f4b166&scoped=true&"
import script from "./noise.vue?vue&type=script&lang=js&"
export * from "./noise.vue?vue&type=script&lang=js&"
import style0 from "./noise.vue?vue&type=style&index=0&id=34f4b166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4b166",
  null
  
)

export default component.exports